/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/**
 * Returns the index of the end of a string
 * @param string - the string you want to search in
 * @param searchString - the string you want to search
 */
export function indexOfEnd(string: string|undefined, searchString: string|undefined) {
    if (string && searchString) {
        var io = string.indexOf(searchString);
        return io == -1 ? -1 : io + searchString.length;
    }
    return -1

}
